import './components/sliders.js';
// import './components/select.js';
import './components/burger.js';
// import './components/accordion.js';
import './components/modals.js';
import './components/replaceEl.js';
// import './components/phoneMask.js';
import './components/tabs.js';
// import './components/side-panel.js';
// import './components/closeAlert.js';
// import './components/choices.js';
// import './components/showPassword.js';
import './components/scrollHeader.js';
import './components/smoothLinks.js';
import './components/select.js';








